
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { cx } from '@trinity/chat-components';
import { Brand } from '@/components/icons/Brand';
import type { WorkspaceGlobalSearchBarResultBrand } from '@/types';
import ClickContainer from './Results.ClickContainer';
import styles from './style/Results.Brand.module.css';

export default function ResultsBrand({ className, index, item, highlighted }: Props) {
  return (
    <ClickContainer index={index} item={item}>
      <div className={cx(styles.root, { [styles.highlighted]: highlighted }, className)}>
        <Brand
          className={styles.icon} />
        <div className={styles.details}>
          <div className={styles.name}>{item.name}</div>
          <div className={styles.type}>Brand</div>
        </div>
        {highlighted && (
          <div className={styles.return}>
            <KeyboardReturnIcon />
          </div>
        )}
      </div>
    </ClickContainer>
  );
}

export { ResultsBrand };

type Props = {
  className?: string;
  index: number;
  item: WorkspaceGlobalSearchBarResultBrand;
  highlighted?: boolean;
};
